import { formatCPM, formatBigNumber } from "../../../utils/Utils";


class CampaignPlanningConfirmationPriceDetail{
    constructor(elem){
        this.main = elem;
        this._tec = this.main.querySelector('.tec');
        this._cpm = this.main.querySelector('.cpm');
        this._impressions = this.main.querySelector('.impressions');

    }

    set(data){
        this._tec.innerHTML = formatBigNumber(data.tec);
        this._cpm.innerHTML = formatCPM(data.cpm);
        
        if(data.impressions > 0){
            this._impressions.innerHTML = formatBigNumber(data.impressions);
            this._impressions.parentElement.classList.remove('d-none');
        }else{
            this._impressions.innerHTML = '';
            this._impressions.parentElement.classList.add('d-none');
        }
                
    }
}

export default CampaignPlanningConfirmationPriceDetail;